/**
 * Returns the name of the given type.
 * Caution: Minification can break this!
 * @param type The type to return the name for
 */
export function nameOf(type: any): string {
  return type.name;
}
